import  React, {useEffect} from "react";
import { useState, useContext } from "react";
import { makeStyles, Theme, createStyles } from "@mui/styles";
import * as request from "superagent";
import URLManager from "~common/lib/url-manager";
import CookieManager from "~common/lib/cookie-manager";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Grid,
    Typography,
    Button
  } from "@mui/material";

import DefinitionSection from "~common/form/definition-section-fc";
import {DataContext} from "~common/form/icg-definition-data-provider";
import {PolicyContext} from "~common/form/icg-definition-data-provider";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modalContent: {
      width: 500,
    },
    actionAutoConfirmButtonClass: {
      border: "dashed 1px #dedede",
    },
    modalTitle: {
      padding: "0px 0px 20px 0px",
    },
    gridItem: {
      paddingBottom: "0px !important;",
      paddingTop: "0px !important;",
    },
    controlContainer: {
      width: "100%",
      padding: 0,
    },
    dangerButton: {
      backgroundColor: "#af0202",
      "&:hover": {
        backgroundColor: "#5D0A0A !important",
      },
    },
  })
);

interface FormBasedContainerDialogueProps {
  action: any;
  handleClose: ()=>{}
  handleDispatch: (action: any, actionData: any)=>{}
  task?: any;
}

export const FormBasedContainerDialogue: React.FC<FormBasedContainerDialogueProps> = ({
    action,
    task,
    handleClose,
    handleDispatch
}) => {
  const classes = useStyles();    

  const [fullData, setFullData] = useContext(DataContext);
  const [policyMessages, setPolicyMessages] = useContext(PolicyContext);

  const [open, setOpen] = useState(undefined)
  const [error, setError] = useState(undefined)
  const [formDefinition, setFormDefinition] = useState(undefined)
  const [validating, setValidating] = useState(undefined)

  const {dialogueOptions} = action

  const _handleDispatch = () => {
    var { dialogueOptions } = action;
    var { cacheDurationDays } = dialogueOptions;
    if (handleDispatch) {
      if (dialogueOptions && dialogueOptions.validationURL) {

        if (!validating) {
          setValidating(true)

            request
              .put(dialogueOptions.validationURL)
              .send({
                formSelector: dialogueOptions.formSelector,
                data: fullData,
              })
              .then((response: request.Response) => {
                if (
                  response.body &&
                  response.body.policyMessages &&
                  response.body.policyMessages.length > 0
                ) {
                  setPolicyMessages(response.body.policyMessages)
                  setValidating(false)
                } else {
                  if (cacheDurationDays) {
                    cacheFormData(cacheDurationDays);
                  }

                  handleDispatch(action, fullData);
                }
              })
              .catch((err) => {
                setValidating(false)
                setError((err.response || { text: err.toString() }).text)
              });          
        }
      
      } else {
        if (cacheDurationDays) {
          cacheFormData(cacheDurationDays);
        }

        handleDispatch(action, fullData);
      }
    }
  }

  const cacheFormData = (durationDays: number) => {
    CookieManager.setCookie(
      `formBasedTaskContainerDialogue|${window.location.pathname}`,
      JSON.stringify(fullData),
      durationDays
    );
  };

  useEffect(() => {
    var { dialogueOptions } = action;

    var _fullData: any = {};

    if (dialogueOptions.formSelector) {
      request
        .get(
          `/api/form-definitions/select?selector=${URLManager.getQueryStringValue(
            dialogueOptions.formSelector
          )}`
        )
        .then((response: request.Response) => {
          var { cacheDurationDays } = dialogueOptions;
          if (cacheDurationDays) {
            var ps = CookieManager.getCookie(
              `formBasedTaskContainerDialogue|${window.location.pathname}`
            );
            if (ps != "") {
              // attempt to set the data value using cookie
              try {
                var parsed = JSON.parse(ps);
                _fullData = parsed;
              } catch (e) {
                // cached value just does not get applied
              }
            }
          }

          _fullData._task = task;

          setFullData(_fullData)
          setFormDefinition(response.body)
          setOpen(true)
        })
        .catch((err: any) => {
          setError((err.response || { text: err.toString() }).text)
        });
    } else {
      setOpen(true)
    }
  }, [])

  return (
    <Dialog
        className={classes.modal}
        open={open || false}
        onClose={handleClose}
      >
        <DialogContent className={classes.modalContent}>
          <DialogTitle className={classes.modalTitle}>
            {action.dialogueOptions.title}
          </DialogTitle>
          <Grid container spacing={3}>
            {!error && action.dialogueOptions.message && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography
                  dangerouslySetInnerHTML={{
                    __html: action.dialogueOptions.message,
                  }}
                  variant="body1"
                ></Typography>
              </Grid>
            )}
            {error && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Typography
                  style={{ color: "red" }}
                  dangerouslySetInnerHTML={{ __html: error }}
                  variant="body1"
                ></Typography>
              </Grid>
            )}
            {formDefinition && (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                    <DefinitionSection
                        definition={formDefinition}
                        path={""}
                        gridSpacing={4}
                        preventCollapse={true}
                        suppressTitle={true}
                    />
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions style={{ justifyContent: "flex-start" }}>
          <div style={{ flex: 1 }}></div>
          <Button
            variant="contained"
            color="inherit"
            onClick={handleClose}
          >
            {dialogueOptions.cancelTitle || "No"}
          </Button>
          {
            <Button
              autoFocus={true}
              variant="contained"
              color="primary"
              onClick={_handleDispatch}
            >
              {dialogueOptions.confirmTitle || "Yes"}
            </Button>
          }
        </DialogActions>
    </Dialog>
  )
};

export default FormBasedContainerDialogue;
